/* eslint-disable max-len */
import React from 'react';
import Button from './Button';
import ApplyNowHeader from './ApplyNowHeader';

interface ConsentPopupProps {
  jobTitle: string;
  handleProceed: () => void;
  resumeName: string;
  candidateName: string | null;
  proceed: () => void;
}

function ConsentPopup({
  jobTitle, resumeName, handleProceed, candidateName, proceed,
}: ConsentPopupProps) {
  return (
    <div className="mx-auto w-full max-w-[660px]">
      <ApplyNowHeader resumeName={resumeName} candidateName={candidateName} />
      <section className="space-y-6">
        <h2 className="mb-2 font-semibold text-lg">
          Job Profile -
          {' '}
          {jobTitle}

        </h2>
        <div className="border-[#d9d9db] mt-0 p-4 border border-solid rounded-lg">
          <div className="p-2">
            <span className="font-bold text-[#00349A] text-3xl">
              To help us understand you better, answer tailored questions to assess your fit for this role.
            </span>
            <p className="m-0 text-lg">Instructions:</p>
            <p className="my-0 text-[#727272] text-lg">
              Welcome to the next step of your application process!
              <br />
              To better understand how you approach challenges and your fit for this role, we have prepared a few tailored questions.
            </p>
            <p className="my-0 text-[#727272] text-lg">
              In the next screen you will be asked a series of questions, you should speak them aloud using the voice option. Let&apos;s get started!
            </p>
            {/* <p className="my-0 text-[#727272] text-lg">
              If you didn&apos;t like any response after recording or faced any glitches while recording, you can re-record the voice response.
            </p> */}
          </div>
        </div>
      </section>
      <div className="flex justify-center items-center space-x-4 mt-8">
        <Button
          onClick={() => proceed()}
          variant="outlined"
        >
          Skip this step
        </Button>
        <Button
          onClick={handleProceed}
          variant="contained"
        >
          Proceed
        </Button>
      </div>
    </div>
  );
}

export default ConsentPopup;
